import { render, staticRenderFns } from "./ContactMassMessaging.vue?vue&type=template&id=80c94b16&scoped=true&"
import script from "./ContactMassMessaging.vue?vue&type=script&lang=js&"
export * from "./ContactMassMessaging.vue?vue&type=script&lang=js&"
import style0 from "./ContactMassMessaging.vue?vue&type=style&index=0&id=80c94b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c94b16",
  null
  
)

export default component.exports